<template>
  <div>
    <v-expansion-panels class="rounded-card" focusable>
      <v-expansion-panel active-class="rounded-card">
        <v-expansion-panel-header>
          <px-cotacao-resposta-comprador-card-header :cotacao="cotacao"
                                                     @movimentada="onMovimentarCotacao"/>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <px-cotacao-resposta-comprador-card-details :cotacao="cotacao"
                                                      :solicitacoes="solicitacoes"
                                                      @update="onMovimentarCotacao"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import CotacaoRespostaCompradorCardDetails from './CotacaoRespostaCompradorCardDetails.vue';
import CotacaoRespostaCompradorCardHeader from './CotacaoRespostaCompradorCardHeader.vue';

export default {
  props: {
    solicitacoes: Array,
    cotacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onMovimentarCotacao(cotacao) {
      this.$emit('movimentada', cotacao);
    },
  },
  components: {
    pxCotacaoRespostaCompradorCardDetails: CotacaoRespostaCompradorCardDetails,
    pxCotacaoRespostaCompradorCardHeader: CotacaoRespostaCompradorCardHeader,
  },
};
</script>
